import React, { useState } from 'react';
import useNearbyNetworks from '@/hooks/useNearbyNetworks';

const FILESTACK_HOST = 'https://cdn.filestackcontent.com/';

export default function Networks(props) {
  const networks = useNearbyNetworks();

  const getResizedLogo = (url) => {
    if (url && url.startsWith(FILESTACK_HOST)) {
      return url.replace(FILESTACK_HOST, `${FILESTACK_HOST}resize=width:128/`);
    }
    return url;
  };

  return (
    <div className="grid grid-cols-2 gap-0.5 place-items-center" data-testid="network-logos">
      { networks.data.map((network) => (
        <div key={network.id}>
          <img src={getResizedLogo(network.logo)}
               className={`object-contain ${networks.data.length === 1 ? 'h-28 w-64' : 'h-14 w-32'}`}
               alt={network.name} title={network.name}/>
        </div>
        ))
      }
    </div>
  )
}
